// extracted by mini-css-extract-plugin
export default {"faqContainer":"Faq_faqContainer__j7dGN","faqHeader":"Faq_faqHeader__UzW2n","section":"Faq_section__Pc6yc"};